













































import Vue from "vue";
//  import { mapGetters } from 'vuex';

export default Vue.extend({
  data() {
    return {
      dialog: false,
    };
  },
  props: {
    label: {
      type: String,
      default: "z-form",
    },
    title: {
      type: String,
      default: "z-form",
    },
    titleColor: {
      type: String,
      default: "indigo",
    },
    titleTextColor: {
      type: String,
      default: "white--text",
    },
    onConfirm: {
      type: Function,
      default: () => {
        return true;
      },
    },

    width: {
      type: Number,
      default: 560,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    isValid: {
      type: Boolean,
      default: true,
    },

    tooltip: {
      type: String,
      default: "none",
    },

    icon: {
      type: String,
      default: "none",
    },

    dark: {
      type: Boolean,
      default: false,
    },

    color: {
      type: String,
      default: "success",
    },

    xSmall: {
      type: Boolean,
      default: false,
    },

    small: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    activatorClass() {
      return this.class;
    },
  },

  methods: {
    open() {
      this.dialog = true;
    },
    confirm() {
      this.dialog = false;
      this.$emit("onConfirm");
    },
  },

  watch: {
    dialog(val) {
      if (val) this.$emit("onOpen");
    },
  },

  components: {},
});
